export const float2027 = {
  title: 'E io, chi sono?',
  year: '2027',
  sketchImage: '/images/bozzetto-2027.jpg',
  sketchPost: 'https://www.instagram.com/p/DdPuEOqKeTb/',
  presentationPost: 'https://www.instagram.com/p/DdPxHZ2q-Fp/',
  sketchSource: 'https://www.obiettivo100.it/2026/09/14/svelati-i-bozzetti-del-carnevale-larte-di-fare-festa/',
  titleSource: 'https://www.ilrestodelcarlino.it/ferrara/cosa-fare/carnevale-ecco-i-cinque-carri-3fadf928',
};